import { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertTriangle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 min

/**
 * AdminEmailQuotaBanner
 *
 * Polls /api/admin/email/status every 5 min. When quota_state==='exceeded',
 * shows a top-level red banner. Never crashes; on endpoint error it stays
 * silent.
 */
export default function AdminEmailQuotaBanner() {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchStatus = async () => {
      try {
        const token = localStorage.getItem('access_token');
        const res = await axios.get(`${API_URL}/api/admin/email/status`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          withCredentials: true,
          timeout: 8000,
        });
        if (!cancelled) {
          setStatus(res.data);
          setError(false);
        }
      } catch (e) {
        if (!cancelled) setError(true);
      }
    };
    fetchStatus();
    const id = setInterval(fetchStatus, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  if (error || !status) return null;
  if (status.quota_state !== 'exceeded') return null;

  const today = status.today || {};
  return (
    <div
      data-testid="admin-email-quota-banner"
      className="bg-red-50 border-l-4 border-red-500 px-4 py-3 mb-4 flex items-start gap-3 rounded-r"
      role="alert"
    >
      <AlertTriangle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <div className="font-semibold text-red-800">
          Resend daglimiet bereikt
        </div>
        <div className="text-red-700 mt-1">
          {status.warning ||
            'Aanvragen worden opgeslagen, maar e-mails worden later/niet verzonden.'}
        </div>
        <div className="text-red-600/80 text-xs mt-1.5">
          Vandaag: {today.sent || 0} verzonden · {today.quota_exceeded || 0} quota geweigerd ·
          {' '}{today.failed || 0} mislukt totaal
        </div>
      </div>
    </div>
  );
}
